import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-resize-icon',
  templateUrl: 'resize-icon.component.html'
})
export class ResizeIconComponent {
  constructor() {}
}
